import { datadogLogs } from "@datadog/browser-logs";

export class SwivlException {
  static capture(error: Error, message?: string, data?: Record<string, unknown>) {
    const context = {
      ...(message && { message }),
      ...(error?.message && { errorMessage: error.message }),
      ...(data && { data })
    };

    try {
      datadogLogs.logger.error(message || error?.message || "Error", Object.keys(context).length > 0 ? context : undefined, error);
    } catch (e) {
      console.error("Error capturing error", e);
    }
  }
}
